// @flow
import React from 'react';
import PropTypes from 'prop-types';
import classes from './OrderSku.module.css';
import { MACHINE_ORDER, KIOSK_ORDER, FAILED_ORDER } from '../../constants';

type Props = {|
	sku: Object,
	orderType: string,
|};

function OrderSku({ sku = {}, orderType }: Props) {
	const {
		image_url,
		image,
		name,
		door_id = null,
		tray_id = null,
		unit_price,
		delivery_type,
		customer_status,
		cstatus,
	} = sku;
	const qty = orderType === MACHINE_ORDER ? sku.purchased_qty || sku.qty : sku.qty;
	// const amount = sku.amount || sku.sku_total;
	const status = customer_status || cstatus;
	return (
		<section className={classes.container}>
			<figure className={classes.imageContainer}>
				<img src={image_url || image || '/images/fastfood.png'} alt='sku' className={classes.productImage} />
			</figure>
			<main className={classes.desc}>
				{/* <div className={classes.category}>Stuffed bakes and cakes</div> */}
				<div style={{ wordBreak: 'break-all' }}>{name}</div>
				<div className={classes.trayContainer}>
					{orderType === MACHINE_ORDER || orderType === KIOSK_ORDER ? (
						<React.Fragment>
							{door_id !== null && (
								<React.Fragment>
									<span>DOOR </span>
									<span>{door_id}, </span>
								</React.Fragment>
							)}
							{tray_id !== null && (
								<React.Fragment>
									<span>TRAY </span>
									<span>#{tray_id}</span>
								</React.Fragment>
							)}
						</React.Fragment>
					) : (
						<span>{delivery_type}</span>
					)}
				</div>
				{/* <div>{weight} gm</div> */}
			</main>
			<aside className={classes.sideContainer}>
				{/* {offerJsx} */}
				<div>
					<div>
						&#x20b9;{unit_price} x {`${qty} unit${qty > 1 ? 's' : ''}`}
					</div>
					<div style={{ textDecoration: status === FAILED_ORDER ? 'line-through' : 'none' }}>
						&#x20b9; {unit_price * qty}
					</div>
				</div>
				<div className={classes.status} style={{ color: status === FAILED_ORDER ? 'red' : 'inherit' }}>
					{customer_status || cstatus}
				</div>
			</aside>
		</section>
	);
}

OrderSku.propTypes = {
	sku: PropTypes.object.isRequired,
};

export default React.memo<Props>(OrderSku);
